import './ProvissionLicensee.css';
import React, { Component } from 'react';
import { Type } from 'react-bootstrap-table2-editor';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Table from '../_components/table/Table';
import ApiKeyForm from '../_components/api_key_form/ApiKeyForm';
import ConfigurationManager from '../_configuration/ConfigurationManager';
import WFTaskClient from '../_clients/WFTaskClient';
import UtilitiesClient from '../_clients/UtilitiesClient';

const LOCAL_STORAGE_API_KEY = 'starLabsSupportConsole.task.apiKey';

const TASK_STATUS_COMPLETE = 'CPL';
const TASK_STATUS_CANCEL = 'LVC';
const TASK_STATUS_NEW = 'NEW';

const ACTION_STATUS_FAILED = -1;
const ACTION_STATUS_READY = 0;
const ACTION_STATUS_LOADING = 1;

const DATE_FORMATTER = (stringDate) => {
	let simplifiedStringDate = stringDate.replace(/:\d{3}-\d{4}/, 'Z'); 
	let date = new Date(simplifiedStringDate);
	return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

const STATUS_FORMATTER = (status) => {
	let icon = null;
	switch(status) {
		case ACTION_STATUS_FAILED:
			icon = <i className="zmdi zmdi-alert-polygon zmdi-hc-2x text-danger"></i>;
			break;
		case ACTION_STATUS_LOADING:
			icon = <i className="zmdi zmdi-rotate-right zmdi-hc-2x text-primary"></i>;
			break;
		case ACTION_STATUS_READY:
			icon = <i className="zmdi zmdi-check-circle zmdi-hc-2x text-success"></i>;
			break;
	}

	return(
		<div className="text-center">
			<div className="text-center">{ icon }</div>
		</div>
	);
}

const COLUMNS = [{
  dataField: 'id',
	text: '#',
	classes: 'hidden-column',
	headerClasses: 'hidden-column',
	sort: true
}, {
  dataField: 'company',
	text: 'Company'
}, {
  dataField: 'contractNumber',
	text: 'Contract Number'
}, {
  dataField: 'firstName',
	text: 'Fist Name'
}, {
  dataField: 'lastName',
	text: 'Last Name'
}, {
  dataField: 'emailAddress',
	text: 'E-Mail Address'
}, {
  dataField: 'jobRole',
	text: 'Job Role'
}, {
  dataField: 'status',
	text: 'Status',
	editor: {
		type: Type.SELECT,
		options: [{
      value: 'NEW',
      label: 'NEW'
    }]
  }
}, {
  dataField: 'entryDate',
	text: 'Entry Date',
	formatter: DATE_FORMATTER,
	editor: {
    type: Type.DATE
  }
}, {
  dataField: 'actionsStatus',
	text: 'Actions Status',
	formatter: STATUS_FORMATTER
}, {
  dataField: 'twId',
	text: 'TW ID',
	classes: 'enriched-column'
}, {
  dataField: 'nuxeoId',
	text: 'Nuxeo ID',
	classes: 'enriched-column'
}, {
  dataField: 'nuxeoCurrentGroups',
	text: 'Nuxeo Current Groups',
	classes: 'enriched-column'
}, {
  dataField: 'workfrontId',
	text: 'Workfront ID',
	classes: 'enriched-column'
}, {
  dataField: 'sameLicensee',
	text: 'Same Licensee',
	classes: 'enriched-column',
	editor: {
    type: Type.CHECKBOX
  }
}, {
  dataField: 'roleUpgrade',
	text: 'Role Upgrade',
	classes: 'enriched-column',
	editor: {
    type: Type.CHECKBOX
  }
}, {
  dataField: 'nuxeoGroupLicensee',
	text: 'Nuxeo Group Licensee',
	classes: 'enriched-column'
}, {
  dataField: 'nuxeoGroupLob',
	text: 'Nuxeo Group LOB',
	classes: 'enriched-column',
	editor: {
		type: Type.SELECT,
		options: [{
      value: 'lob:fashionHome',
      label: 'Fashion Home'
		},
		{
      value: 'lob:toys',
      label: 'Toys'
		},
		{
      value: 'lob:publishing',
      label: 'Publishing'
		},
		{
      value: 'lob:gte',
      label: 'GTE'
    }]
  }
}, {
  dataField: 'nuxeoGroupRole',
	text: 'Nuxeo Group Role',
	classes: 'enriched-column',
	editor: {
		type: Type.SELECT,
		options: [{
      value: 'rle:licensee',
      label: 'Licensee'
		},
		{
      value: 'rle:licenseeDesigner',
      label: 'Licensee Designer'
		},
		{
      value: 'rle:wbcpCreative',
      label: 'WBCP Creative'
		},
		{
      value: 'rle:wbcp',
      label: 'WBCP'
		}]
  }
}, {
  dataField: 'workfrontCompanyId',
	text: 'Workfront Company ID',
	classes: 'enriched-column'
}, {
  dataField: 'workfrontGroupId',
	text: 'Workfront Group ID',
	classes: 'enriched-column'
}, {
  dataField: 'workfrontTeamId',
	text: 'Workfront Team ID',
	classes: 'enriched-column'
}];

const ROW_MAPPER = (record) => {
	return ({
			id: record.ID,
			taskName: record.name,
			assignments: '',
			company: record.parameterValues['DE:Company'],
			contractNumber: record.parameterValues['DE:Contract #'],
			firstName: record.parameterValues['DE:First Name'],
			lastName: record.parameterValues['DE:Last Name'],
			emailAddress: record.parameterValues['DE:Email Address'],
			jobRole: record.parameterValues['DE:Role'],
			status: TASK_STATUS_NEW,
			referenceNumber: '',
			lastNote: record.lastNote != null ? record.lastNote.name : null,
			entryDate: record.entryDate,
			actionsStatus: ACTION_STATUS_READY
	});
}

class ProvissionLicensee extends Component {
  constructor(props) {
    super(props);
    this.state = {
			enrichmentEnabled: false,
			apiKey: window.localStorage.getItem(LOCAL_STORAGE_API_KEY),
			addressesToCopy: ''
		};

		this._parent = this.props.parent;

		this._wfTaskClient = new WFTaskClient();
		this._utilitiesClient = new UtilitiesClient();

		this._handleOnProvisionClick = this._handleOnProvisionClick.bind(this);
		this._handleOnEnrichClick = this._handleOnEnrichClick.bind(this);
		this._handleOnCompleteClick = this._handleOnCompleteClick.bind(this);
		this._handleOnChangeApiClick = this._handleOnChangeApiClick.bind(this);
		this._handleOnRefreshClick = this._handleOnRefreshClick.bind(this);
		this._handleSelect = this._handleSelect.bind(this);
		this._handleOnApiKeyChange = this._handleOnApiKeyChange.bind(this);

		this._getRecords = this._getRecords.bind(this);
		this._countRecords = this._countRecords.bind(this);
	}
	
	_handleOnEnrichClick() {
		let sessionInfo = this._parent.sessionInfo;
		if (!sessionInfo.logged) {
			sessionInfo.showLoginForm();
			return;
		}

		this._table.selectedRows.forEach((row) => {
			row.actionsStatus = ACTION_STATUS_LOADING;
			this._table.editRow(row.id, row);

			let body = {
				users: [
					{
						firstName: row.firstName,
						lastName: row.lastName,
						email: row.emailAddress,
						contractNo: row.contractNumber,
						nuxeoGroupLob: row.nuxeoGroupLob,
						jobRole: row.jobRole
					}
				]
			};

			let successCallback = function(row, response) {
				let enrichedUser = response.users[0];
				const newRow = {
					id: row.id,
					taskName: row.taskName,
					company: enrichedUser.company,
					contractNumber: row.contractNumber,
					firstName: enrichedUser.firstName,
					lastName: enrichedUser.lastName,
					emailAddress: enrichedUser.email,
					jobRole: row.jobRole,
					status: TASK_STATUS_NEW,
					referenceNumber: '',
					lastNote: row.lastNote,
					entryDate: row.entryDate,
					actionsStatus: row.actionsStatus,
					nuxeoId: enrichedUser.nuxeoId,
					twId: enrichedUser.twId,
					nuxeoCurrentGroups: enrichedUser.nuxeoCurrentGroups,
					nuxeoGroupLob: enrichedUser.nuxeoGroupLob,
					nuxeoGroupRole: enrichedUser.nuxeoGroupRole,
					nuxeoGroupLicensee: enrichedUser.nuxeoGroupLicensee,
					workfrontId: enrichedUser.workfrontId,
					sameLicensee: enrichedUser.sameLicensee,
					roleUpgrade: enrichedUser.roleUpgrade,
					workfrontCompanyId: enrichedUser.workfrontCompanyId,
					workfrontGroupId: enrichedUser.workfrontGroupId,
					workfrontTeamId: enrichedUser.workfrontTeamId,
					actionsStatus: ACTION_STATUS_READY
				}

				this._table.editRow(row.id, newRow);
			}

			let errorCallback = function(row, error) {
				row.actionsStatus = ACTION_STATUS_FAILED;
				this._table.editRow(row.id, row);
			}

			this._utilitiesClient.enrichMetadata(body, sessionInfo.accessToken)
				.then(successCallback.bind(this, row))
				.catch(errorCallback.bind(this, row));
		});
	}

	_handleOnProvisionClick() {
		let sessionInfo = this._parent.sessionInfo;
		if (!sessionInfo.logged) {
			sessionInfo.showLoginForm();
			return;
		}

		this._table.selectedRows.forEach((row) => {
			row.actionsStatus = ACTION_STATUS_LOADING;
			this._table.editRow(row.id, row);

			let body = {
				twId: row.twId,
				firstName: row.firstName,
				lastName: row.lastName,
				email: row.emailAddress,
				company: row.company,
				nuxeoGroupRole: row.nuxeoGroupRole,
				nuxeoGroupLicensee: row.nuxeoGroupLicensee,
				nuxeoGroupLob: row.nuxeoGroupLob,
				workfrontCompanyId: row.workfrontCompanyId,
				workfrontGroupId: row.workfrontGroupId,
				workfrontTeamId: row.workfrontTeamId
			}

			let successCallback = function(row, response) {
				row.twId = response.twResult;
				row.nuxeoId = response.nuxeoResult;
				row.workfrontId = response.workfrontResult;
				row.actionsStatus = ACTION_STATUS_READY;

				this._table.editRow(row.id, row);
			}

			let errorCallback = function(row, error) {
				row.actionsStatus = ACTION_STATUS_FAILED;
				this._table.editRow(row.id, row);
			}

			this._utilitiesClient.provisionUser(body, sessionInfo.accessToken)
				.then(successCallback.bind(this, row))
				.catch(errorCallback.bind(this, row));
		});
	}

	_handleOnCompleteClick() {
		this._table.selectedRows.forEach((row) => {
			row.actionsStatus = ACTION_STATUS_LOADING;
			this._table.editRow(row.id, row);

			let successCallback = function(row, response) {
				row.status = TASK_STATUS_COMPLETE;
				row.actionsStatus = ACTION_STATUS_READY;

				this._table.editRow(row.id, row);
			}

			let errorCallback = function(row, error) {
				row.actionsStatus = ACTION_STATUS_FAILED;
				this._table.editRow(row.id, row);
			}

			this._wfTaskClient.updateStatus(row.id, TASK_STATUS_COMPLETE, this.state.apiKey)
				.then(successCallback.bind(this))
				.catch(errorCallback.bind(this));
		});
	}

	_handleOnChangeApiClick() {
		this._apiKeyForm.show();
	}

	_handleOnRefreshClick() {
		this._table.refresh();
	}	

	_handleSelect(event) {
		this.setState({ enrichmentEnabled: event.detail.selected.length > 0 });
		
		let addressesToCopy = this._table.selectedRows.map((row) => row.emailAddress);
		addressesToCopy = addressesToCopy.join(';');

		this.setState({
			addressesToCopy: addressesToCopy
		});
	}

	_handleOnApiKeyChange(event) {
		const { apiKey } = event.detail;
		window.localStorage.setItem(LOCAL_STORAGE_API_KEY, apiKey);

		let stateChangeCallback = function() {
			this._table.refresh();
		}

		this.setState({ apiKey: apiKey }, stateChangeCallback.bind(this));
	}

	_getRecords(page, sizePerPage, callback) {
		let apiKey = this.state.apiKey;
		let offset = (page - 1) * sizePerPage;
		let projectId = ConfigurationManager.getProperty('WF_TASK_API_LICENSEE_PROJECT_ID');

		this._wfTaskClient.searchByStatus(TASK_STATUS_NEW, projectId, apiKey, sizePerPage, offset)
			.then(response => callback(response.data))
			.catch(response => callback([]));
	}

	_countRecords(callback) {
		let apiKey = this.state.apiKey;
		let projectId = ConfigurationManager.getProperty('WF_TASK_API_LICENSEE_PROJECT_ID');

		this._wfTaskClient.countByStatus(TASK_STATUS_NEW, projectId, apiKey)
			.then(response => callback(response.data.count))
			.catch(response => callback(0));
	}

  render() {
		const { enrichmentEnabled } = this.state;

    return(
				<div className="row">
					<div className="col">
						<div className="card">
							<div className="card-header">
								<h2 className="card-title">Provision Licensee User Account</h2>
								<div className="hidden-sm-down actions">
									<div className="actions-group">
										<button id="change-api-btn" className={ "btn btn-outline-info" } onClick={ this._handleOnChangeApiClick }>
											<i className="zmdi zmdi-code-setting"></i> Change API Key
										</button>
										<button id="change-api-btn" className={ "btn btn-outline-info" } onClick={ this._handleOnRefreshClick }>
											<i className="zmdi zmdi-refresh-alt"></i> Refresh
										</button>
									</div>
									<div className="actions-group">
										<button id="enrich-btn" className={ "btn btn-outline-success" + (!enrichmentEnabled ? "disabled" : "") } disabled={ !enrichmentEnabled } onClick={ this._handleOnEnrichClick }>
											<i className="zmdi zmdi-open-in-browser"></i> Enrich
										</button>
										<button id="provision-btn" className={ "btn btn-outline-success" + (!enrichmentEnabled ? "disabled" : "") } disabled={ !enrichmentEnabled } onClick={ this._handleOnProvisionClick }>
											<i className="zmdi zmdi-account-add"></i> Provision
										</button>
										<CopyToClipboard text={ this.state.addressesToCopy }>
											<button id="copy-btn" className={ "btn btn-outline-success" + (!enrichmentEnabled ? "disabled" : "") } disabled={ !enrichmentEnabled } onClick={ this._handleOnCopyClick }>
												<i className="zmdi zmdi-copy"></i> Copy E-Mail
											</button>
										</CopyToClipboard>
										<button id="complete-btn" className={ "btn btn-outline-success" + (!enrichmentEnabled ? "disabled" : "") } disabled={ !enrichmentEnabled } onClick={ this._handleOnCompleteClick }>
											<i className="zmdi zmdi-assignment-check"></i> Complete Task
										</button>
									</div>
								</div>
							</div>
							<div className="card-body">
								<Table ref={ element => this._table = element }
									keyField="id" 
									columns={ COLUMNS } 
									selectionMode="checkbox" 
									editionMode="dbclick" 
									onSelect={ this._handleSelect }
									recordsProvider={ this._getRecords }
									recordsCountProvider={ this._countRecords }
									rowMapper={ ROW_MAPPER }></Table>
							</div>
						</div>
					</div>
					<ApiKeyForm ref={ element => this._apiKeyForm = element } apiKey={ this.state.apiKey }  onSubmit={ this._handleOnApiKeyChange }></ApiKeyForm>
				</div>
			);
  }
}

export default ProvissionLicensee;


// WEBPACK FOOTER //
// ./src/provission_licensee/ProvissionLicensee.jsx